import React from 'react'

function Pay() {
    return (
        <div>
            <h2>payment system coming soon</h2>
        </div>
    )
}

export default Pay
